import { addHeaderToLayout } from "src/app/ReportGenerator/functions/addHeaderToLayout";
import { addSpaceIfNeeded } from "../addSpaceIfNeeded";

export const addSentimentAnalysisToLayout = (
  newLayout,
  format,
  campaigns,
  dataAggregation,
  campaignId,
  sentimentValues,
) => {
  if (!sentimentValues) return;

  const isSingleCampaign = Object.keys(campaigns).length === 1;
  const headerDepth = campaignId !== "aggregated" && !isSingleCampaign ? 3 : 2;

  addHeaderToLayout(
    `sentiment-analysis-${campaignId}`,
    newLayout,
    format,
    headerDepth,
  );

  Object.entries(sentimentValues).forEach((item) => {
    const [key] = item;

    const lastEl = addSpaceIfNeeded("sentiment-analysis", newLayout, format);

    let x = 0;
    let y = 0;
    const w = 3;
    const h = 2;

    // first in row and half the width
    const spaceLeft = 12 - (lastEl.x + lastEl.w);

    if (spaceLeft >= 3) {
      x = lastEl.x + lastEl.w;
      y = lastEl.y;
    } else {
      x = 0;
      y = lastEl.y + lastEl.h;
    }

    const i = `sentiment-analysis-${key}-${campaignId}`;
    newLayout.push({ i, x, y, w, h });
  });
};
